import React from 'react'
import BottomSheetContent from '../BottomSheetComponents/BottomSheetContent'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'

interface RankExplanationBottomSheetProps {
  onDismiss: () => void
  ScreenName: string
}

export const RankExplanationBottomSheet: React.FC<RankExplanationBottomSheetProps> = ({
  onDismiss,
  ScreenName
}) => {
  const handleClose = () => {
    trackEvent({
      eventName: EventNames.UserClicked,
      payload: {
        eventId: 'RankExplanationBottomSheet',
        responseName: 'Close',
        screenType: ScreenName,
      }
    })
    onDismiss()
  }

  return (
    <BottomSheetContent
      bottomSheetHeadingClassName="!font-normal"
      heading="Why is Rank 1 not always recommended?"
      logoSrc="/images/power-rebalance/manual-book.png"
      onDismiss={handleClose}
      bottomSheetBodyClassName="!px-0"
    >
      <div className='text-grey40 text-13 px-5'>
              When we suggest a switch, we don’t just look at the fund’s current rank.
              <br /><br />
              We simulate your exact investment journey — every SIP, lump sum, or withdrawal — against all top-ranked funds in the same category. The fund that delivers the best outcome for you (in terms of XIRR + missed gains) is the one we recommend.
              <br /><br />
              That's why recommendations can differ from person to person.
              <br /><br />
              All funds ranked 1, 2, and 3 in a category are strong performers and suitable for switching.
              <br /><br />
              If you prefer a specific Fund House, you’re free to pick any among the Top 3 ranked funds in the same category.
      </div>
    </BottomSheetContent>
  )
}
